import { render, staticRenderFns } from "./BatchToBeConfirmed.vue?vue&type=template&id=20eae0a1&scoped=true"
import script from "./BatchToBeConfirmed.vue?vue&type=script&lang=js"
export * from "./BatchToBeConfirmed.vue?vue&type=script&lang=js"
import style0 from "./BatchToBeConfirmed.vue?vue&type=style&index=0&id=20eae0a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eae0a1",
  null
  
)

export default component.exports